var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburgerMini = function SvgHamburgerMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hamburger_mini_svg__st0{fill:none;stroke:#000;stroke-width:1.3;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger_mini_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hamburger_mini_svg__st0",
    d: "M14.9 17.8h18.2M14.9 23.8h18.2M14.9 29.8h18.2"
  }))));
};
export default SvgHamburgerMini;